
export const getCustomTheme = themeMode => {
  const light = themeMode === "light"
  const theme = {
    palette: {
      mode: themeMode,
      background: {
        default: light ? '#ffffff' : '#181818',
        paper: light ? '#ffffff' : '#181818',
      },
      primary: {
        // main: '#2cff05',
        main: '#aaff00',
        dark: "#45cc2d"
      },
      secondary: {
        main: '#5500ff',
      },
      warning: {
        main: '#F7D448',
      },
      text: {
        main: '#000000DE',
      },
      snackbar: {
        main: '#182518',
      },
      white: {
        main: '#FAFAFA',
      },
      error: {
        main: '#F7484E'
      },
      info: {
        main: '#4871F7'
      },
      grey: {
        main: "#CDCDCD",
        transparent: "#CDCDCD99",
        light: "#E1E1E1",
      },
      ...(light ?
        { text: { primary: "#151515" } }
        : { text: { primary: "#FAFAFA" } }
      ),
    },
    typography: {
      fontFamily: 'Poppins',
      h4: {
        fontWeight: '300',
      },
      h5: {
        fontWeight: '300',
      },
      h6: {
        fontWeight: '300',
      },
      subtitle1: {
        fontWeight: '400',
      },
      subtitle2: {
        fontWeight: '500',
      },
      body1: {
        fontWeight: '400',
      },
      body2: {
        fontWeight: '400',
      },
      button: {
        fontFamily: 'Poppins',
        fontWeight: '500',
        // letterSpacing: '1.44px',
        borderRadius: '18px'
      },
      caption: {
        fontWeight: '400',
      },
      overline: {
        fontFamily: 'Poppins',
        fontWeight: '300',
        textTransform: 'uppercase',
        // letterSpacing: '1.44px',
      },
      projectTitle: {
        fontFamily: 'Poppins',
        fontWeight: '500',
        textTransform: 'uppercase',
        fontSize: "1.20vw",
      },
      funnyTitle: {
        "& span": {
          display: "inline-block",
          animation: "fadeMove 2s ease infinite",
          "&:nth-of-type(n+1)": {
            animationDelay: "1s"
          },
          "&:nth-of-type(n+2)": {
            animationDelay: "1.1s"
          },
          "&:nth-of-type(n+3)": {
            animationDelay: "1.2s"
          },
          "&:nth-of-type(n+4)": {
            animationDelay: "1.3s"
          },
          "&:nth-of-type(n+5)": {
            animationDelay: "1.4s"
          },
          "&:nth-of-type(n+6)": {
            animationDelay: "1.5s"
          },
          "&:nth-of-type(n+7)": {
            animationDelay: "1.6s"
          },
          "&:nth-of-type(n+8)": {
            animationDelay: "1.7s"
          },
          "&:nth-of-type(n+9)": {
            animationDelay: "1.8s"
          },
          "&:nth-of-type(n+10)": {
            animationDelay: "1.9s"
          },
          "&:nth-of-type(n+11)": {
            animationDelay: "2.0s"
          },
        },

        "@keyframes fadeMove": {
          "0%": {
            transform: "translateY(0px) ",
          },
          "33%": {
            transform: "translateY(-20px) scale(1.1)",
          },
          "40%": {
            transform: "translateY(0px)",
          },
          "100%": {
            transform: "translateY(0)"
          }
        }

      }
    },
    components: {
      MuiTooltip: {
        styleOverrides: {
          popper: {
          },
          tooltip: {
            "&.transparent": {
              backgroundColor: 'transparent',
            },
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            borderRadius: '50px',
            backdropFilter: 'blur(8px)',
          }
        }
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            "&.MuiTypography-projectTitle": {
              fontFamily: 'Poppins',
              fontWeight: '700',
              textTransform: 'uppercase',
              fontSize: "10vw",
              mixBlendMode: "difference",
              color: "white",
              lineHeight: "0.9",
              letterSpacing: "0.001em",
              "&.small": {
                fontSize: "7vw",
              }
            },
          }
        },
      },
      MuiTextField: {
        defaultProps: {
          InputProps: {
            spellCheck: 'false'
          }
        }
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: '32px',
            padding: "8px 16px",
            textTransform: 'none',
          }
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            fontFamily: 'Poppins',
            letterSpacing: '0.19px',
          },
          icon: {
            width: '16px',
            height: '16px',
          },
          colorPrimary: {
            backgroundColor: '#4871F73D',
            color: '#4871F7',
          },
        },
      },
      MuiCheckbox: {
        styleOverrides: {
          root: {
            color: themeMode === 'light' ? '#00000059' : '#FFFFFF59',
            "&.Mui-checked": {
              svg: {
                borderRadius: '4px',
              },
            },
          },
        },
      },
      MuiRadio: {
        styleOverrides: {
          root: {
            "&:not(.Mui-checked)": {
              svg: {
                fill: '#00000059',
              },
            },
          },
        },
      },
      MuiFromControl: {
        styleOverrides: {
          root: {
            width: '100%',
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            fontSize: '14px',
            letterSpacing: '1.2px',
            fontWeight: 400,
            color: '#4871F7',
          },
        },
      },
      MuiSimpleTreeView: {
        styleOverrides: {
          root: {
          },
        },
      },
      MuiTreeItem: {
        styleOverrides: {
          root: {
            '& .MuiTreeItem-content': {
              flexDirection: 'row-reverse',
              borderRadius: '4px',
            },
            '& .MuiTreeItem-content.Mui-selected': {
              backgroundColor: '#4871F71F !important',
              color: '#4871F7 !important',
            },
            '& .MuiTreeItem-content:hover': {
              backgroundColor: '#4871F714 !important',
            },
          },
          label: {
            '& .MuiBox-root': {
              height: '40px',
            },
            '& .MuiTypography-body2': {
              fontFamily: 'Poppins',
              fontWeight: '400',
              fontSize: '14px',
              letterSpacing: '0.22px',
              lineHeight: '18px',
            },
          },
        },
      },
      MuiDrawer: {
        styleOverrides: {
          root: ({ theme }) => ({
            '& .MuiBox-root.box_transparent': {
              padding: '16px',
              borderRadius: '24px',
              // backdropFilter: 'blur(8px)',
              // backgroundColor: getTransparentBgColor(themeMode)
              backgroundColor: theme.palette.background.paper
            },
          }),
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            '&.product_card': {
              borderRadius: '8px',
            },
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          outlined: {
            border: '0px !important',
            outline: themeMode === 'light' ? '1px solid #0000001F' : '1px solid #FFFFFF1F',
            '&.blur': {
              backdropFilter: 'blur(8px)',
            },
          },
        },
      },
      MuiToolbar: {
        styleOverrides: {
          root: {
            '&#back-to-top-anchor': {
              minHeight: "0px",
              height: "0px"
            }
          }
        }
      },
      MuiGrid2: {
        styleOverrides: {
          root: ({ theme }) => ({
            '&.roundAndBlur': {
              backgroundColor: theme.palette.background.paper + "33",
              backdropFilter: "blur(40px)",
              padding: "40px",
              borderRadius: "40px",
              [theme.breakpoints.down('md')]: {
                marginTop: "20px",
                padding: "24px",
                borderRadius: "24px",
              },
            }
          }),
        }
      },
      MuiSwitch: {
        styleOverrides: {
          root: ({ theme }) => ({
            width: 52,
            height: 32,
            padding: 0,
            '& .Mui-checked': {
              '+ .MuiSwitch-track': {
                borderColor: "transparent",
                background: theme.palette.primary,
                opacity: 1,
              },
              '&.MuiSwitch-switchBase': {
                padding: 0,
                margin: "4px",
              },
              '& .MuiSwitch-thumb': {
                boxSizing: 'border-box',
                width: 24,
                height: 24,
                position: "relative",
                padding: 2,
                background: theme.palette.background.default,
                '&:before': {
                  content: `""`,
                  boxSizing: 'border-box',
                  position: "absolute",
                  display: "block",
                  width: 20,
                  height: 20,
                  backgroundPosition: 'center',
                  backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
                    '#444444',
                  )
                    }" d="M21, 7L9, 19L3.5, 13.5L4.91, 12.09L9, 16.17L19.59, 5.59L21, 7Z"/></svg>')`,
                  backgroundRepeat: "no-repeat"
                },
              },
            },
            '& .MuiSwitch-switchBase': {
              padding: "0",
              margin: 8,
            },
            '& .MuiSwitch-thumb': {
              boxSizing: 'border-box',
              width: 16,
              height: 16,
              background: theme.palette.action.active,
            },
            '& .MuiSwitch-track': {
              borderRadius: 32 / 2,
              opacity: 1,
              background: theme.palette.background.default,
              border: `1px solid ${theme.palette.action.active}`,
            },
          })
        }
      }
    },
  }
  return theme
}

export const getTransparentBgColor = mode =>
  mode === 'light' ? "#f5f5f4D9" : "#111111D9"
